var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex w-100 justify-content-center flex-wrap"},_vm._l((_vm.entries),function(entry){return _c('div',{key:entry.name,staticClass:"entry"},[_c('span',{staticClass:"entryColor",class:entry.name}),_vm._v("  "),_c('span',[_vm._v(_vm._s(entry.displayName))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }